import React from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link, NavLink } from "react-router-dom";
import style from "./index.module.scss";
import MSALogo from "../../../assets/images/msa__logo--alternate.png";
// import ProfileImg from "../../../assets/images/profileimg.png";
import * as authActions from "../../../redux/actions/authActions";
import Modal from "../../Modal";
import Button from "../../Button";
import { useDispatch, useSelector } from "react-redux";
import { clearErrorMessage } from "../../../redux/actions/messageActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate } from "react-router-dom";

// import DashboardIcon from "../../../assets/icons/Dashboard/DashboardIcon.svg";
// import FillerIcon from "../../../assets/icons/Dashboard/filler_icon.svg";

export default function Layout({ children, pageTitle, navLinks }) {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.auth.authState);
  const token = sessionStorage.getItem("msa_jwt");
  const notification = useSelector((state) => state.message);

  const [isOpen, setOpen] = React.useState(false);

  const handleNav = () => {
    setOpen(!isOpen);
  };

  const navigation = [
    {
      route: "/dashboard",
      label: "Home",
      route_name: "Dashboard",
      icon: (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.8333 16.9457V12.7791C10.8333 12.116 10.5699 11.4801 10.1011 11.0113C9.63226 10.5425 8.99637 10.2791 8.33333 10.2791C7.67029 10.2791 7.03441 10.5425 6.56557 11.0113C6.09672 11.4801 5.83333 12.116 5.83333 12.7791V16.9457H1.66667C1.22464 16.9457 0.800716 16.7701 0.488155 16.4576C0.175595 16.145 0 15.7211 0 15.2791V6.22241C-2.76895e-06 5.9346 0.0745255 5.65169 0.216328 5.40124C0.358129 5.15078 0.562372 4.94132 0.809167 4.79324L7.47583 0.793241C7.73486 0.637823 8.03126 0.555725 8.33333 0.555725C8.63541 0.555725 8.93181 0.637823 9.19083 0.793241L15.8575 4.79324C16.1043 4.94132 16.3085 5.15078 16.4503 5.40124C16.5921 5.65169 16.6667 5.9346 16.6667 6.22241V15.2791C16.6667 15.7211 16.4911 16.145 16.1785 16.4576C15.8659 16.7701 15.442 16.9457 15 16.9457H10.8333Z"
            fill="#828282"
          />
        </svg>
      ),
    },
    {
      route: "/wallet",
      label: "Wallet",
      icon: (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.875 3.97035H1.59375V3.4391L13.2812 2.5041V3.4391H14.875V1.84535C14.875 0.676603 13.9283 -0.143647 12.7723 0.0210404L2.10375 1.54467C0.946688 1.71042 0 2.8016 0 3.97035V14.5954C0 15.1589 0.223883 15.6994 0.622398 16.098C1.02091 16.4965 1.56141 16.7204 2.125 16.7204H14.875C15.4386 16.7204 15.9791 16.4965 16.3776 16.098C16.7761 15.6994 17 15.1589 17 14.5954V6.09535C17 5.53177 16.7761 4.99127 16.3776 4.59275C15.9791 4.19424 15.4386 3.97035 14.875 3.97035ZM13.2812 11.4142C13.0719 11.4142 12.8646 11.3729 12.6712 11.2927C12.4778 11.2125 12.3021 11.095 12.1541 10.9469C12.0061 10.7988 11.8887 10.623 11.8087 10.4296C11.7286 10.2361 11.6874 10.0288 11.6875 9.81942C11.6876 9.61005 11.7289 9.40275 11.8091 9.20935C11.8892 9.01595 12.0067 8.84024 12.1548 8.69224C12.3029 8.54425 12.4787 8.42688 12.6722 8.34682C12.8656 8.26676 13.0729 8.2256 13.2823 8.22567C13.7051 8.22581 14.1106 8.39391 14.4095 8.693C14.7084 8.99208 14.8762 9.39765 14.8761 9.82048C14.8759 10.2433 14.7078 10.6488 14.4087 10.9476C14.1096 11.2465 13.7041 11.4144 13.2812 11.4142Z"
            fill="#828282"
          />
        </svg>
      ),
    },
    {
      external: true,
      route: "https://documentation.myserviceagent.net/?curl#otp-apis",
      label: "OTP and Alerts",
      icon: (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.96657 6.80005C3.81628 6.80005 3.67215 6.85975 3.56588 6.96602C3.4596 7.07229 3.3999 7.21643 3.3999 7.36672V9.63338C3.3999 9.78367 3.4596 9.92781 3.56588 10.0341C3.67215 10.1403 3.81628 10.2 3.96657 10.2C4.11686 10.2 4.26099 10.1403 4.36726 10.0341C4.47353 9.92781 4.53324 9.78367 4.53324 9.63338V7.36672C4.53324 7.21643 4.47353 7.07229 4.36726 6.96602C4.26099 6.85975 4.11686 6.80005 3.96657 6.80005Z"
            fill="#828282"
          />
          <path
            d="M12.4668 7.93338H13.0335C13.1838 7.93338 13.3279 7.87368 13.4342 7.76741C13.5404 7.66114 13.6001 7.517 13.6001 7.36672C13.6001 7.21643 13.5404 7.07229 13.4342 6.96602C13.3279 6.85975 13.1838 6.80005 13.0335 6.80005H12.4668V7.93338Z"
            fill="#828282"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.497918 0.497918C0.179107 0.81673 0 1.24913 0 1.7V15.3C0 15.7509 0.179107 16.1833 0.497918 16.5021C0.81673 16.8209 1.24913 17 1.7 17H15.3C15.7509 17 16.1833 16.8209 16.5021 16.5021C16.8209 16.1833 17 15.7509 17 15.3V1.7C17 1.24913 16.8209 0.81673 16.5021 0.497918C16.1833 0.179107 15.7509 0 15.3 0H1.7C1.24913 0 0.81673 0.179107 0.497918 0.497918ZM2.39607 6.7161C2.31064 6.92236 2.26667 7.14342 2.26667 7.36667V9.63333C2.26667 9.85658 2.31064 10.0776 2.39607 10.2839C2.4815 10.4901 2.60673 10.6776 2.76459 10.8354C2.92244 10.9933 3.10985 11.1185 3.3161 11.2039C3.52236 11.2894 3.74342 11.3333 3.96667 11.3333C4.18991 11.3333 4.41097 11.2894 4.61723 11.2039C4.82348 11.1185 5.01089 10.9933 5.16875 10.8354C5.32661 10.6776 5.45183 10.4901 5.53726 10.2839C5.62269 10.0776 5.66667 9.85658 5.66667 9.63333V7.36667C5.66667 7.14342 5.62269 6.92236 5.53726 6.7161C5.45183 6.50985 5.32661 6.32244 5.16875 6.16459C5.01089 6.00673 4.82348 5.8815 4.61723 5.79607C4.41097 5.71064 4.18991 5.66667 3.96667 5.66667C3.74342 5.66667 3.52236 5.71064 3.3161 5.79607C3.10985 5.8815 2.92244 6.00673 2.76459 6.16459C2.60673 6.32244 2.4815 6.50985 2.39607 6.7161ZM6.8 6.8H7.93333V11.3333H9.06667V6.8H10.2V5.66667H6.8V6.8ZM13.0333 5.66667H11.3333V11.3333H12.4667V9.06667H13.0333C13.4842 9.06667 13.9166 8.88756 14.2354 8.56875C14.5542 8.24994 14.7333 7.81753 14.7333 7.36667C14.7333 6.9158 14.5542 6.4834 14.2354 6.16459C13.9166 5.84577 13.4842 5.66667 13.0333 5.66667Z"
            fill="#828282"
          />
        </svg>
      ),
    },
    {
      route: "/user/send-messages/developer",
      label: "Send Messages",
      icon: (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.3 0H1.7C0.765 0 0.00849999 0.765 0.00849999 1.7L0 17L3.4 13.6H15.3C16.235 13.6 17 12.835 17 11.9V1.7C17 0.765 16.235 0 15.3 0ZM5.95 7.65H4.25V5.95H5.95V7.65ZM9.35 7.65H7.65V5.95H9.35V7.65ZM12.75 7.65H11.05V5.95H12.75V7.65Z"
            fill="#828282"
          />
        </svg>
      ),
    },
    {
      route: "/user/sender-id",
      label: "Sender ID",
      icon: (
        <svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8033 0.125H1.63664C0.857471 0.125 0.219971 0.7625 0.219971 1.54167V11.4583C0.219971 12.2375 0.857471 12.875 1.63664 12.875H15.8033C16.5825 12.875 17.2129 12.2375 17.2129 11.4583L17.22 1.54167C17.22 0.7625 16.5825 0.125 15.8033 0.125ZM15.8033 11.4583H1.63664V1.54167H15.8033V11.4583ZM15.095 2.25H10.1366V5.79167H15.095V2.25ZM14.3866 3.66667L12.6158 4.90625L10.845 3.66667V2.95833L12.6158 4.19792L14.3866 2.95833V3.66667ZM6.59497 6.5C7.76372 6.5 8.71997 5.54375 8.71997 4.375C8.71997 3.20625 7.76372 2.25 6.59497 2.25C5.42622 2.25 4.46997 3.20625 4.46997 4.375C4.46997 5.54375 5.42622 6.5 6.59497 6.5ZM6.59497 3.66667C6.98455 3.66667 7.3033 3.98542 7.3033 4.375C7.3033 4.76458 6.98455 5.08333 6.59497 5.08333C6.20539 5.08333 5.88664 4.76458 5.88664 4.375C5.88664 3.98542 6.20539 3.66667 6.59497 3.66667ZM10.845 9.75125C10.845 7.98042 8.03289 7.21542 6.59497 7.21542C5.15705 7.21542 2.34497 7.98042 2.34497 9.75125V10.75H10.845V9.75125ZM4.10164 9.33333C4.6258 8.97917 5.67414 8.625 6.59497 8.625C7.5158 8.625 8.55705 8.97208 9.0883 9.33333H4.10164Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      route: "/user/whatsapp-template",
      label: "WhatsApp Template",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      ),
    },
    {
      route: "/user/usage-report",
      label: "Usage Reports",
      icon: (
        <svg
          width="15"
          height="17"
          viewBox="0 0 15 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8179 17H1.06787C0.780111 17 0.531087 16.8976 0.320801 16.6929C0.110514 16.4881 0.00537109 16.2363 0.00537109 15.9375V1.0791C0.00537109 0.780273 0.110514 0.528483 0.320801 0.32373C0.531087 0.118978 0.780111 0.0166016 1.06787 0.0166016H8.50537V5.86035C8.50537 6.00423 8.55794 6.12874 8.66309 6.23389C8.76823 6.33903 8.89274 6.3916 9.03662 6.3916H14.8804V15.9375C14.8804 16.2363 14.778 16.4881 14.5732 16.6929C14.3685 16.8976 14.1167 17 13.8179 17ZM12.2241 13.8125H11.6929V10.0938C11.6929 9.94987 11.6403 9.82536 11.5352 9.72021C11.43 9.61507 11.3055 9.5625 11.1616 9.5625H10.0991C9.95524 9.5625 9.83073 9.61507 9.72559 9.72021C9.62044 9.82536 9.56787 9.94987 9.56787 10.0938V13.8125H8.50537V7.96875C8.50537 7.82487 8.4528 7.70036 8.34766 7.59521C8.24251 7.49007 8.118 7.4375 7.97412 7.4375H6.91162C6.76774 7.4375 6.64323 7.49007 6.53809 7.59521C6.43294 7.70036 6.38037 7.82487 6.38037 7.96875V13.8125H5.31787V11.1562C5.31787 11.0124 5.2653 10.8879 5.16016 10.7827C5.05501 10.6776 4.9305 10.625 4.78662 10.625H3.72412C3.58024 10.625 3.45573 10.6776 3.35059 10.7827C3.24544 10.8879 3.19287 11.0124 3.19287 11.1562V13.8125H2.66162C2.51774 13.8125 2.39323 13.8651 2.28809 13.9702C2.18294 14.0754 2.13037 14.1999 2.13037 14.3438C2.13037 14.4876 2.18294 14.6121 2.28809 14.7173C2.39323 14.8224 2.51774 14.875 2.66162 14.875H12.2241C12.3791 14.875 12.5063 14.8224 12.606 14.7173C12.7056 14.6121 12.7554 14.4876 12.7554 14.3438C12.7554 14.1999 12.7028 14.0754 12.5977 13.9702C12.4925 13.8651 12.368 13.8125 12.2241 13.8125ZM9.56787 0C9.85563 0 10.0991 0.0996094 10.2983 0.298828L14.5649 4.56543C14.7752 4.77572 14.8804 5.03027 14.8804 5.3291H9.56787V0Z"
            fill="#828282"
          />
        </svg>
      ),
    },
    {
      route: "/user/phonebook",
      label: "Phonebook",
      icon: (
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9434 15.9375H14.8809V11.6875H15.9434C16.2422 11.6875 16.494 11.7899 16.6987 11.9946C16.9035 12.1994 17.0058 12.4512 17.0058 12.75V14.875C17.0058 15.1738 16.9035 15.4256 16.6987 15.6304C16.494 15.8351 16.2422 15.9375 15.9434 15.9375ZM15.9434 10.625H14.8809V6.375H15.9434C16.2422 6.375 16.494 6.47738 16.6987 6.68213C16.9035 6.88688 17.0058 7.13867 17.0058 7.4375V9.5625C17.0058 9.86133 16.9035 10.1131 16.6987 10.3179C16.494 10.5226 16.2422 10.625 15.9434 10.625ZM15.9434 5.3125H14.8809V1.0625H15.9434C16.2422 1.0625 16.494 1.16488 16.6987 1.36963C16.9035 1.57438 17.0058 1.82617 17.0058 2.125V4.25C17.0058 4.54883 16.9035 4.80062 16.6987 5.00537C16.494 5.21012 16.2422 5.3125 15.9434 5.3125ZM13.8184 15.9375C13.8184 16.2253 13.716 16.4743 13.5112 16.6846C13.3065 16.8949 13.0547 17 12.7559 17H1.06836C0.780599 17 0.531575 16.8949 0.321289 16.6846C0.111003 16.4743 0.00585938 16.2253 0.00585938 15.9375V1.0625C0.00585938 0.763672 0.111003 0.511882 0.321289 0.307129C0.531575 0.102376 0.780599 0 1.06836 0H12.7559C13.0547 0 13.3065 0.102376 13.5112 0.307129C13.716 0.511882 13.8184 0.763672 13.8184 1.0625V15.9375ZM7.97461 10.1934V9.89453C9.0371 9.46289 9.56835 8.28971 9.56835 6.375C9.56835 5.67773 9.3221 5.14925 8.82959 4.78955C8.33707 4.42985 7.70068 4.25 6.92041 4.25C6.14013 4.25 5.50097 4.42985 5.00293 4.78955C4.50488 5.14925 4.25586 5.67773 4.25586 6.375C4.25586 8.23438 4.78711 9.40202 5.84961 9.87793V10.1934C5.08593 10.3262 4.45508 10.5752 3.95703 10.9404C3.45898 11.3057 3.20443 11.7207 3.19336 12.1855C3.19336 12.3184 3.31234 12.4263 3.55029 12.5093C3.78825 12.5923 4.13688 12.6504 4.59619 12.6836C5.0555 12.7168 5.43457 12.7362 5.7334 12.7417C6.03222 12.7472 6.42513 12.75 6.91211 12.75C7.39908 12.75 7.79199 12.7472 8.09082 12.7417C8.38964 12.7362 8.76871 12.7168 9.22802 12.6836C9.68733 12.6504 10.036 12.5923 10.2739 12.5093C10.5119 12.4263 10.6309 12.3184 10.6309 12.1855C10.6198 11.7207 10.3652 11.3057 9.86718 10.9404C9.36913 10.5752 8.73828 10.3262 7.97461 10.1934Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      route: "/user/analytics",
      label: "Analytics",
      icon: (
        <svg
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 9.20833H1.41667V9.5625H0.708333V10.2708H1.41667V10.625H0V11.3333H2.125V8.5H0V9.20833ZM0.708333 2.83333H1.41667V0H0V0.708333H0.708333V2.83333ZM0 4.95833H1.275L0 6.44583V7.08333H2.125V6.375H0.85L2.125 4.8875V4.25H0V4.95833ZM3.54167 0.708333V2.125H13.4583V0.708333H3.54167ZM3.54167 10.625H13.4583V9.20833H3.54167V10.625ZM3.54167 6.375H13.4583V4.95833H3.54167V6.375Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      route: "/user/settings",
      label: "Settings",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2581 7.70805L15.3598 7.14139C15.2285 6.68313 15.048 6.24044 14.8215 5.82106L15.7508 4.0814C15.7857 4.01574 15.7984 3.94058 15.7872 3.86708C15.776 3.79358 15.7413 3.72566 15.6885 3.6734L14.3341 2.31341C14.2819 2.26052 14.214 2.2259 14.1405 2.21467C14.067 2.20344 13.9918 2.21621 13.9261 2.25108L12.1978 3.17474C11.7743 2.93711 11.3258 2.74707 10.8605 2.60808L10.2938 0.732419C10.2698 0.663295 10.2246 0.603559 10.1645 0.561809C10.1044 0.520059 10.0326 0.498448 9.95948 0.500087H8.04416C7.97057 0.500429 7.89902 0.524246 7.8399 0.568071C7.78079 0.611896 7.73721 0.673442 7.71549 0.743752L7.14883 2.61374C6.67964 2.752 6.2273 2.94205 5.80017 3.18041L4.10018 2.26241C4.03451 2.22754 3.95935 2.21477 3.88585 2.226C3.81236 2.23723 3.74444 2.27186 3.69218 2.32474L2.31519 3.66774C2.2623 3.72 2.22767 3.78791 2.21644 3.86141C2.20521 3.93491 2.21798 4.01007 2.25285 4.07574L3.17085 5.77573C2.93288 6.20106 2.74283 6.65148 2.60419 7.11872L0.728529 7.68538C0.658219 7.7071 0.596673 7.75068 0.552848 7.80979C0.509023 7.86891 0.485206 7.94046 0.484863 8.01405V9.92937C0.485206 10.003 0.509023 10.0745 0.552848 10.1336C0.596673 10.1927 0.658219 10.2363 0.728529 10.258L2.61552 10.8247C2.75568 11.2842 2.9457 11.7269 3.18218 12.145L2.25285 13.9244C2.21798 13.99 2.20521 14.0652 2.21644 14.1387C2.22767 14.2122 2.2623 14.2801 2.31519 14.3323L3.66951 15.6867C3.72177 15.7396 3.78969 15.7742 3.86319 15.7854C3.93669 15.7966 4.01185 15.7839 4.07751 15.749L5.8285 14.814C6.24271 15.0375 6.67964 15.2161 7.13183 15.3467L7.69849 17.2563C7.72021 17.3266 7.76379 17.3882 7.8229 17.432C7.88202 17.4758 7.95357 17.4997 8.02716 17.5H9.94248C10.0161 17.4997 10.0876 17.4758 10.1467 17.432C10.2058 17.3882 10.2494 17.3266 10.2711 17.2563L10.8378 15.341C11.2861 15.2098 11.7192 15.0312 12.1298 14.8083L13.8921 15.749C13.9578 15.7839 14.033 15.7966 14.1065 15.7854C14.1799 15.7742 14.2479 15.7396 14.3001 15.6867L15.6545 14.3323C15.7073 14.2801 15.742 14.2122 15.7532 14.1387C15.7644 14.0652 15.7517 13.99 15.7168 13.9244L14.7761 12.1677C15.0013 11.7556 15.1818 11.3205 15.3145 10.87L17.2241 10.3034C17.2944 10.2817 17.356 10.2381 17.3998 10.179C17.4436 10.1198 17.4674 10.0483 17.4678 9.9747V8.04238C17.4711 7.97192 17.4528 7.90212 17.4153 7.84236C17.3779 7.78259 17.323 7.73573 17.2581 7.70805ZM9.00182 12.1167C8.3854 12.1167 7.78283 11.9339 7.2703 11.5914C6.75777 11.249 6.3583 10.7622 6.12241 10.1927C5.88652 9.62324 5.8248 8.99659 5.94506 8.39202C6.06531 7.78745 6.36214 7.23211 6.79801 6.79624C7.23389 6.36037 7.78922 6.06354 8.39379 5.94328C8.99836 5.82302 9.62502 5.88474 10.1945 6.12063C10.764 6.35653 11.2508 6.75599 11.5932 7.26853C11.9357 7.78106 12.1185 8.38363 12.1185 9.00004C12.1185 9.82663 11.7901 10.6194 11.2056 11.2038C10.6211 11.7883 9.82841 12.1167 9.00182 12.1167Z"
            fill="#828282"
          />
        </svg>
      ),
    },
  ];

  const toggleVerificationModal = () => {
    // dispatch(authActions.updateUser(formData, id));

    const id = state.id;

    const formData = new FormData();
    formData.append("accepted_terms", "yes");
    formData.append("token", token);
    formData.append("id", id);

    dispatch(authActions.updateUser(formData, id));
    dispatch(clearErrorMessage());
  };

  return (
    <div className={style["layout__container"]}>
      <nav
        className={
          style[
            isOpen
              ? "layout__container--sidebar-open"
              : "layout__container--sidebar"
          ]
        }
      >
        <NavLink to="/">
          <div className={style["logo__container"]}>
            <img src={MSALogo} alt="msa__logo" />
          </div>
        </NavLink>

        <FontAwesomeIcon
          icon={faTimes}
          onClick={() => handleNav()}
          className={style["menu__button-close"]}
        />

        <ul>
          {navigation.map((item, index) =>
            item.external ? (
              <a href={item.route} key={index}>
                {" "}
                <li>
                  <span style={{ marginRight: "1rem" }}>{item.icon}</span>

                  {item.label}
                </li>
              </a>
            ) : (
              <NavLink
                key={index}
                className={({ isActive }) => (isActive ? style["active"] : "")}
                to={item.route}
              >
                <li>
                  <span style={{ marginRight: "1rem" }}>{item.icon}</span>
                  {item.label}
                </li>
              </NavLink>
            )
          )}

          <NavLink
            to="/login"
            onClick={() => {
              dispatch(authActions.logout());
            }}
            className={style["logout"]}
          >
            <li>
              <span style={{ marginRight: "1rem" }}>
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5274 9.24982C10.1434 9.24982 9.83301 9.56097 9.83301 9.94421V12.722C9.83301 13.1047 9.52186 13.4164 9.13849 13.4164H7.05518V2.99988C7.05518 2.40682 6.6774 1.87697 6.10939 1.67975L5.90378 1.61096H9.13849C9.52186 1.61096 9.83301 1.92274 9.83301 2.30548V4.38879C9.83301 4.77204 10.1434 5.08319 10.5274 5.08319C10.9114 5.08319 11.2218 4.77204 11.2218 4.38879V2.30548C11.2218 1.15689 10.2871 0.222168 9.13849 0.222168H1.67332C1.64688 0.222168 1.62475 0.233993 1.59907 0.237427C1.56562 0.234629 1.53371 0.222168 1.49976 0.222168C0.733774 0.222168 0.11084 0.844975 0.11084 1.61096V14.1108C0.11084 14.7039 0.488618 15.2337 1.05662 15.431L5.23584 16.8241C5.37749 16.8678 5.51838 16.8887 5.66638 16.8887C6.43237 16.8887 7.05518 16.2657 7.05518 15.4998V14.8054H9.13849C10.2871 14.8054 11.2218 13.8706 11.2218 12.722V9.94421C11.2218 9.56097 10.9114 9.24982 10.5274 9.24982Z"
                    fill="#828282"
                  />
                  <path
                    d="M16.5736 6.67546L13.7958 3.89775C13.5973 3.69913 13.2986 3.63937 13.0389 3.74694C12.7799 3.85465 12.6104 4.10807 12.6104 4.3887V6.47201H9.83271C9.44933 6.47201 9.13818 6.78303 9.13818 7.16641C9.13818 7.54978 9.44933 7.8608 9.83271 7.8608H12.6104V9.94412C12.6104 10.2247 12.7799 10.4782 13.0389 10.5859C13.2986 10.6934 13.5973 10.6337 13.7958 10.4352L16.5736 7.65735C16.8451 7.38588 16.8451 6.94694 16.5736 6.67546Z"
                    fill="#828282"
                  />
                </svg>
              </span>
              Logout
            </li>
          </NavLink>
        </ul>
      </nav>

      <main>
        <TopNav
          state={state}
          pageTitle={pageTitle}
          isOpen={isOpen}
          handleNav={handleNav}
        />
        <Modal isOpen={notification.id === "TERMS"}>
          <header>
            <h1>Hi, There's something missing.</h1>
            <p>We need your consent on the terms and condtions,</p>
            <p> Do you accept the conditions?</p>

            <Button
              type="button"
              onClick={() => toggleVerificationModal()}
              className="filled"
            >
              I Accept the terms and conditions
            </Button>
            <Link to="/login">
              <Button
                type="button"
                style={{
                  marginTop: "16px",
                }}
                onClick={() => dispatch(authActions.logout())}
                className="medium--ghost"
              >
                I don't accept the conditions
              </Button>
            </Link>
          </header>
        </Modal>
        {children}
      </main>
    </div>
  );
}

const TopNav = ({ state, pageTitle, handleNav }) => {
  return (
    <nav className={style["topnav__links"]}>
      <div className={style["menu"]}>
        <FontAwesomeIcon
          icon={faBars}
          onClick={() => handleNav()}
          className={style["menu__button-open"]}
        />
        <h4>{pageTitle}</h4>
      </div>
      <ul className={style["topnav__links--container"]}>
        <a href="https://documentation.myserviceagent.net/">
          <li>API Documentation</li>
        </a>
        {/* <li>
          <ScrollLink to="user" spy={true} smooth={true}>
            Help Center
          </ScrollLink>
        </li> */}
        <ScrollLink
          to="user"
          smooth={true}
          onClick={() => window.location.replace(`/contact-us`)}
        >
          <li style={{ cursor: "pointer" }}>Contact us</li>
        </ScrollLink>
      </ul>
    </nav>
  );
};
